import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

export const useTranslation = () => {
  const { lang, switchLanguage, toggleLanguage } = useLanguage();

  const t = (key, fallback) => {
    const keys = key.split('.');
    let value = translations[lang];
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        // Fallback to English
        let enValue = translations.en;
        for (const ek of keys) {
          if (enValue && typeof enValue === 'object' && ek in enValue) {
            enValue = enValue[ek];
          } else {
            return fallback || key;
          }
        }
        return enValue;
      }
    }
    return value;
  };

  return { t, lang, switchLanguage, toggleLanguage };
};
